import { render, staticRenderFns } from "./LicencesAdmin.vue?vue&type=template&id=7ddaaa46"
import script from "./LicencesAdmin.vue?vue&type=script&lang=js"
export * from "./LicencesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports